import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as dom from '../../base/browser/dom.js';
import { GlobalMouseMoveMonitor } from '../../base/browser/globalMouseMoveMonitor.js';
import { StandardMouseEvent } from '../../base/browser/mouseEvent.js';
import { Disposable } from '../../base/common/lifecycle.js';
/**
 * Coordinates relative to the whole document (e.g. mouse event's pageX and pageY)
 */

export var PageCoordinates = /*#__PURE__*/function () {
  function PageCoordinates(x, y) {
    _classCallCheck(this, PageCoordinates);

    this.x = x;
    this.y = y;
  }

  _createClass(PageCoordinates, [{
    key: "toClientCoordinates",
    value: function toClientCoordinates() {
      return new ClientCoordinates(this.x - dom.StandardWindow.scrollX, this.y - dom.StandardWindow.scrollY);
    }
  }]);

  return PageCoordinates;
}();
/**
 * Coordinates within the application's client area (i.e. origin is document's scroll position).
 *
 * For example, clicking in the top-left corner of the client area will
 * always result in a mouse event with a client.x value of 0, regardless
 * of whether the page is scrolled horizontally.
 */

export var ClientCoordinates = /*#__PURE__*/function () {
  function ClientCoordinates(clientX, clientY) {
    _classCallCheck(this, ClientCoordinates);

    this.clientX = clientX;
    this.clientY = clientY;
  }

  _createClass(ClientCoordinates, [{
    key: "toPageCoordinates",
    value: function toPageCoordinates() {
      return new PageCoordinates(this.clientX + dom.StandardWindow.scrollX, this.clientY + dom.StandardWindow.scrollY);
    }
  }]);

  return ClientCoordinates;
}();
/**
 * The position of the editor in the page.
 */

export var EditorPagePosition = function EditorPagePosition(x, y, width, height) {
  _classCallCheck(this, EditorPagePosition);

  this.x = x;
  this.y = y;
  this.width = width;
  this.height = height;
};
export function createEditorPagePosition(editorViewDomNode) {
  var editorPos = dom.getDomNodePagePosition(editorViewDomNode);
  return new EditorPagePosition(editorPos.left, editorPos.top, editorPos.width, editorPos.height);
}
export var EditorMouseEvent = /*#__PURE__*/function (_StandardMouseEvent) {
  _inherits(EditorMouseEvent, _StandardMouseEvent);

  var _super = _createSuper(EditorMouseEvent);

  function EditorMouseEvent(e, editorViewDomNode) {
    var _this;

    _classCallCheck(this, EditorMouseEvent);

    _this = _super.call(this, e);
    _this.pos = new PageCoordinates(_this.posx, _this.posy);
    _this.editorPos = createEditorPagePosition(editorViewDomNode);
    return _this;
  }

  return EditorMouseEvent;
}(StandardMouseEvent);
export var EditorMouseEventFactory = /*#__PURE__*/function () {
  function EditorMouseEventFactory(editorViewDomNode) {
    _classCallCheck(this, EditorMouseEventFactory);

    this._editorViewDomNode = editorViewDomNode;
  }

  _createClass(EditorMouseEventFactory, [{
    key: "_create",
    value: function _create(e) {
      return new EditorMouseEvent(e, this._editorViewDomNode);
    }
  }, {
    key: "onContextMenu",
    value: function onContextMenu(target, callback) {
      var _this2 = this;

      return dom.addDisposableListener(target, 'contextmenu', function (e) {
        callback(_this2._create(e));
      });
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp(target, callback) {
      var _this3 = this;

      return dom.addDisposableListener(target, 'mouseup', function (e) {
        callback(_this3._create(e));
      });
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(target, callback) {
      var _this4 = this;

      return dom.addDisposableListener(target, 'mousedown', function (e) {
        callback(_this4._create(e));
      });
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave(target, callback) {
      var _this5 = this;

      return dom.addDisposableNonBubblingMouseOutListener(target, function (e) {
        callback(_this5._create(e));
      });
    }
  }, {
    key: "onMouseMoveThrottled",
    value: function onMouseMoveThrottled(target, callback, merger, minimumTimeMs) {
      var _this6 = this;

      var myMerger = function myMerger(lastEvent, currentEvent) {
        return merger(lastEvent, _this6._create(currentEvent));
      };

      return dom.addDisposableThrottledListener(target, 'mousemove', callback, myMerger, minimumTimeMs);
    }
  }]);

  return EditorMouseEventFactory;
}();
export var EditorPointerEventFactory = /*#__PURE__*/function () {
  function EditorPointerEventFactory(editorViewDomNode) {
    _classCallCheck(this, EditorPointerEventFactory);

    this._editorViewDomNode = editorViewDomNode;
  }

  _createClass(EditorPointerEventFactory, [{
    key: "_create",
    value: function _create(e) {
      return new EditorMouseEvent(e, this._editorViewDomNode);
    }
  }, {
    key: "onPointerUp",
    value: function onPointerUp(target, callback) {
      var _this7 = this;

      return dom.addDisposableListener(target, 'pointerup', function (e) {
        callback(_this7._create(e));
      });
    }
  }, {
    key: "onPointerDown",
    value: function onPointerDown(target, callback) {
      var _this8 = this;

      return dom.addDisposableListener(target, 'pointerdown', function (e) {
        callback(_this8._create(e));
      });
    }
  }, {
    key: "onPointerLeave",
    value: function onPointerLeave(target, callback) {
      var _this9 = this;

      return dom.addDisposableNonBubblingPointerOutListener(target, function (e) {
        callback(_this9._create(e));
      });
    }
  }, {
    key: "onPointerMoveThrottled",
    value: function onPointerMoveThrottled(target, callback, merger, minimumTimeMs) {
      var _this10 = this;

      var myMerger = function myMerger(lastEvent, currentEvent) {
        return merger(lastEvent, _this10._create(currentEvent));
      };

      return dom.addDisposableThrottledListener(target, 'pointermove', callback, myMerger, minimumTimeMs);
    }
  }]);

  return EditorPointerEventFactory;
}();
export var GlobalEditorMouseMoveMonitor = /*#__PURE__*/function (_Disposable) {
  _inherits(GlobalEditorMouseMoveMonitor, _Disposable);

  var _super2 = _createSuper(GlobalEditorMouseMoveMonitor);

  function GlobalEditorMouseMoveMonitor(editorViewDomNode) {
    var _this11;

    _classCallCheck(this, GlobalEditorMouseMoveMonitor);

    _this11 = _super2.call(this);
    _this11._editorViewDomNode = editorViewDomNode;
    _this11._globalMouseMoveMonitor = _this11._register(new GlobalMouseMoveMonitor());
    _this11._keydownListener = null;
    return _this11;
  }

  _createClass(GlobalEditorMouseMoveMonitor, [{
    key: "startMonitoring",
    value: function startMonitoring(initialElement, initialButtons, merger, mouseMoveCallback, onStopCallback) {
      var _this12 = this;

      // Add a <<capture>> keydown event listener that will cancel the monitoring
      // if something other than a modifier key is pressed
      this._keydownListener = dom.addStandardDisposableListener(document, 'keydown', function (e) {
        var kb = e.toKeybinding();

        if (kb.isModifierKey()) {
          // Allow modifier keys
          return;
        }

        _this12._globalMouseMoveMonitor.stopMonitoring(true);
      }, true);

      var myMerger = function myMerger(lastEvent, currentEvent) {
        return merger(lastEvent, new EditorMouseEvent(currentEvent, _this12._editorViewDomNode));
      };

      this._globalMouseMoveMonitor.startMonitoring(initialElement, initialButtons, myMerger, mouseMoveCallback, function () {
        _this12._keydownListener.dispose();

        onStopCallback();
      });
    }
  }]);

  return GlobalEditorMouseMoveMonitor;
}(Disposable);